module.exports = __webpack_public_path__ + "img/tu-2_22.e270a624.jpg";